import { render, staticRenderFns } from "./redirect.vue?vue&type=template&id=765b0ebc&scoped=true&"
import script from "./redirect.vue?vue&type=script&lang=js&"
export * from "./redirect.vue?vue&type=script&lang=js&"
import style0 from "./redirect.vue?vue&type=style&index=0&id=765b0ebc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765b0ebc",
  null
  
)

export default component.exports